import { NEOONEDataProvider } from './NEOONEDataProvider';
import { ProviderBase } from './ProviderBase';
export class NEOONEProvider extends ProviderBase {
    constructor(options = []) {
        super();
        const networks = options.map((opts) => {
            this.mutableProviders[opts.network] = opts instanceof NEOONEDataProvider ? opts : new NEOONEDataProvider(opts);
            return opts.network;
        });
        this.networksInternal$.next(networks);
    }
    createDataProvider(options) {
        return new NEOONEDataProvider(options);
    }
}

//# sourceMappingURL=NEOONEProvider.js.map
